<div class="sg-date-range" [class.sg-date-range--no-subscript]="subscriptSizing === 'none'">
  @if (presets) {
    <sg-dropdown-2
      class="sg-date-range__preset"
      [label]="label"
      [items]="presetOptions"
      [formControl]="presetControl"
      [size]="size"
      [subscriptSizing]="subscriptSizing"
      panelWidth="auto"></sg-dropdown-2>
  }

  @if (showCustomRange) {
    <mat-form-field class="sg-date-range__range" appearance="outline" [subscriptSizing]="subscriptSizing === 'fixed' ? 'fixed' : 'dynamic'">
      @if (!presets && label) {
        <mat-label>{{ label }}</mat-label>
      }
      <mat-date-range-input [formGroup]="rangeGroup" [rangePicker]="picker">
        <input matStartDate formControlName="start" placeholder="From" />
        <input matEndDate formControlName="end" placeholder="To" />
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  }
</div>
